import { createFileRoute } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/vs-veza")({
  loader: async () => {
    const page = await loadBlockPage({ data: { collection: "sp", slug: "vs-veza" } });
    return page;
  },
  head: ({ loaderData }) => ({ meta: seo({ title: (loaderData as any)?.seo_title || (loaderData as any)?.title, description: (loaderData as any)?.seo_description, url: "/vs-veza" }), links: seoLinks({ url: "/vs-veza" }) }),
  component: () => { const p = Route.useLoaderData() as any; return <BlockRenderer blocks={p.blocks || []} />; },
});
